import React from 'react';
import { Link } from 'react-router-dom';
import './Style/NEETImportantInfoTopic.css';

import AllNEETInfo from './AllNEETInfo';
import TopNavbar from '../../home/TopNavbar';
import TopHeader from '../../home/TopHeader';

function NEETImportantInfoTopic() {
    return (
        <div className="information-page">
            <TopNavbar name="NEET Important Information" />
            <TopHeader name="NEET Important Information" />

            <div className="information-categories">
                {AllNEETInfo.map((item) => (
                    <Link
                        to={`/${item.link}`}
                        key={item.id}
                        className="information-card" >

                        <div className="information-card-top">
                            <div className="information-icon">
                                {item.icon}
                            </div>
                            <span className="information-badge">{item.subject} ➔</span>
                        </div>

                        <div className="information-card-bottom">
                            <h2>
                                {item.name}
                                <span className="information-year">2027</span>
                            </h2>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default NEETImportantInfoTopic;